import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const KCPResultMob = () => {
  return <CommonResult />;
};

export default KCPResultMob;
